import { Navigate } from 'react-router'
import { useQuery } from '@tanstack/react-query'
import { getApplication } from '../api/endpoints'
import { ErrorNotice } from '../components'
import { routeFor } from '../lib/routes'

export default function HomeRedirect() {
  // Always ask the server: redirecting on a cached status would send someone back to a step they have just finished.
  const q = useQuery({ queryKey: ['application'], queryFn: getApplication, staleTime: 0, refetchOnMount: 'always' })
  if (q.isPending || q.isFetching) return <p role="status">Loading…</p>
  if (q.isError) return <ErrorNotice error={q.error} />
  return <Navigate to={routeFor(q.data.status)} replace />
}
